import environment from 'environment';

import { makeBetListing } from "@api/models/bet.model";
import { makeBetOverviewListing, makeLeagues } from "@api/models/overview.model";

export class BetOverviewApiService {
  constructor(HttpService, SessionService) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
  }

  getBetOverview(payload) {
    const mergedPayload = Object.assign({id: this.SessionService.get('brokerageSyncId')}, payload);
    const queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);

    return this.HttpService.getNonAsync(`/brokerage/bet-overview?${queryParams}`).then(payload => makeBetOverviewListing(payload));
  }

  getLeagues() {
    return this.HttpService.get(`/brokerage/get-leagues`).then((payload) => {
      return payload.reduce((accumulator, league) => makeLeagues(accumulator, league),  {});
    });
  }

  getBets(payload) {
    const mergedPayload = Object.assign({id: this.SessionService.get('brokerageSyncId')}, payload);
    const queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);

    return this.HttpService.getNonAsync(`/brokerage/get-bets?${queryParams}`).then(payload => makeBetListing(payload));
  }

  exportToCSV(payload) {
    const mergedPayload = Object.assign({id: this.SessionService.get('brokerageSyncId')}, payload);
    const queryParams = this.HttpService.buildQueryParamsFromPayload(mergedPayload);
    let url = environment.API_URL + `/brokerage/export-bets?${queryParams}`;
    window.location.assign(url);
  }
}

export default BetOverviewApiService;


// WEBPACK FOOTER //
// ./client/app/api/services/betoverview.api.service.js